import * as moment from "moment";
import { DataTypeDateData } from "../cotizacion/enum/dataTypeDateData";

export class Tools {
    private static numericMonths = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    private static stringMonths = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    private static formatPattern = "yyyy/MM/dd";
    static moment = moment;

    static getValidityEndFromValidityInit(validityInit: Date, years?: number) {
        try {
            if (years === undefined || (years != undefined && years < 1)) throw new Error('The variable years set by default to 1!');

            return moment(validityInit).add(years, 'year').toDate();
        } catch (ex) {
            return moment(validityInit).add(1, 'year').toDate();
        }
    }

    static getFormatDate(dateFormatConfig: DateFormatConfig): string {
        let formatFecha: string = "";
        let datosFecha: DatosFecha = new DatosFecha();
        if (dateFormatConfig.isDescripcion === undefined) dateFormatConfig.isDescripcion = false;
        if (dateFormatConfig.formater === "" || dateFormatConfig.formater === undefined) dateFormatConfig.formater = this.formatPattern;

        try {
            if (dateFormatConfig.date instanceof Date) {
                let dateFec: Date = new Date(dateFormatConfig.date);
                datosFecha = this.getDatosFecha(DataTypeDateData.STRING, dateFec, dateFormatConfig.addYear);
                if (dateFormatConfig.isDescripcion) {
                    formatFecha = this.getFormatFechaDescripcion(datosFecha);
                } else {
                    formatFecha = dateFormatConfig.formater
                        .replace("yyyy", datosFecha.year.toString())
                        .replace("yy", datosFecha.yeartwo.toString())
                        .replace("MM", this.getMonthNumberText(datosFecha.month))
                        .replace("dd", this._to2digit(datosFecha.day))
                        .replace("hh", this._to2digit(datosFecha.hour)).
                        replace("mm", this._to2digit(datosFecha.minute)).
                        replace("ss", this._to2digit(datosFecha.second));
                }
            } else {
                let delimiter = this.getDelimiter(dateFormatConfig.date);
                if (delimiter !== "") {
                    datosFecha = this.getDatosFecha(DataTypeDateData.DATE, dateFormatConfig.date, dateFormatConfig.addYear, delimiter);
                    if (dateFormatConfig.isDescripcion) {
                        formatFecha = this.getFormatFechaDescripcion(datosFecha)
                    } else {
                        formatFecha = dateFormatConfig.formater
                            .replace("yyyy", datosFecha.year.toString())
                            .replace("MM", this.getMonthNumberText(datosFecha.month))
                            .replace("dd", this._to2digit(datosFecha.day))
                            .replace("hh", this._to2digit(datosFecha.hour))
                            .replace("mm", this._to2digit(datosFecha.minute))
                            .replace("ss", this._to2digit(datosFecha.second));
                    }
                }
            }
        } catch (error) {
            console.error("error", error);
            formatFecha = "";
        }
        return formatFecha;
    }

    private static getDatosFecha(type: number, fecha: any, addYear?: any, delimitador?: string): DatosFecha {
        let datosFecha: DatosFecha = new DatosFecha();
        let _addYear: number = (addYear !== null && addYear !== undefined) ? addYear : 0;

        switch (type) {
            case DataTypeDateData.STRING:
                datosFecha.day = fecha.getDate();
                datosFecha.month = fecha.getMonth();
                datosFecha.year = fecha.getFullYear() + _addYear;
                datosFecha.yeartwo = parseInt((fecha.getFullYear()).toString().substring(2, 4)) + _addYear;
                datosFecha.hour = fecha.getHours();
                datosFecha.minute = fecha.getMinutes();
                datosFecha.second = fecha.getSeconds();
                break;
            case DataTypeDateData.DATE:
                datosFecha.day = parseInt(((fecha.split(delimitador)[0].length == 2) ? fecha.split(delimitador)[0] : fecha.split(delimitador)[2]), 10);
                if (fecha.split(delimitador)[1].length == 3) {
                    datosFecha.month = (this.stringMonths.indexOf(fecha.split(delimitador)[1].toUpperCase()));
                } else {
                    datosFecha.month = parseInt((fecha.split(delimitador)[1]), 10) - 1;
                }
                datosFecha.year = parseInt(((fecha.split(delimitador)[0].length == 4) ? fecha.split(delimitador)[0] : fecha.split(delimitador)[2]), 10) + _addYear;
                break;
        }
        return datosFecha;
    }

    private static getDelimiter(date: string): string {
        let delimitador = "";
        if (date.split("-").length == 3) {
            delimitador = "-";
        } else if (date.split("/").length == 3) {
            delimitador = "/";
        } else if (date.split(" ").length == 3) {
            delimitador = " ";
        }
        return delimitador;
    }

    private static getFormatFechaDescripcion(datosFecha: DatosFecha) {
        return datosFecha.day + ' ' + this.getMonthStringText(datosFecha.month) + ' ' + datosFecha.year;
    }

    private static _to2digit(n: number) {
        return ('00' + n).slice(-2);
    }

    private static getMonthNumberText(month: number): string {
        return this.numericMonths[month];
    }

    private static getMonthStringText(month: number): string {
        return this.stringMonths[month];
    }
}

export class DatosFecha {
    public day: number = 0;
    public month: number = 0;
    public year: number = 0;
    public yeartwo: number = 0;
    public hour: number = 0;
    public minute: number = 0;
    public second: number = 0;
}

/**
 * This help us to date formatting configuration.
 * 
 * @interface dateFormatConfig
 * @member date Represents value to works.
 * @field date Represents value to works.
 */
interface DateFormatConfig {
    date: any,
    isDescripcion?: boolean, //12 OCT 2022
    formater?: string,
    addYear?: number
}

export class GenericDataList {
    public id?: number | undefined;
    public nombre?: string | undefined;
}